<template>
  <a
    :class="{active}"
    :href="path"
    class="menu-item"
    @click.prevent="onClick">
    Contracts
    <span v-if="$store.info.orders" class="info-label">
      + {{ $store.info.orders }} orders
    </span>
  </a>
</template>

<script>
export default {
  data() {
    return {
      title: 'Contracts',
      path: '/contracts'
    };
  },
  computed: {
    active() {
      return this.path === this.$store.path;
    }
  },
  methods: {
    onClick() {
      this.$store.navigate(this.path, {});
    }
  }
};
</script>
